module.exports = __webpack_public_path__ + "static/media/4.20_preview.54726e18.png";